// src/api/apiNationalities.js
import axios from "../utils/axios";

/// Get Nationalities
export const getAllNationalities = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("nationalities", { params });
    return data;
};

/// Get Nationality
export const getNationality = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`nationalities/${id}`);
    return data;
};

/// Create Nationality
export const createNationality = async (req) => {
    try {
        const { data } = await axios.post("nationalities", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createNationality error:", error);
        throw error;
    }
};

/// Update Nationality
export const updateNationality = async (req, id) => {
    try {
        const { data } = await axios.put(`nationalities/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateNationality error:", error);
        throw error;
    }
};

/// Delete Nationality
export const deleteNationality = async (id) => {
    try {
        const { data } = await axios.delete(`nationalities/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteNationality error:", error);
        throw error;
    }
};

/// Delete All Nationalities
export const deleteAllNationalities = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "nationalities/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllNationalities error:", error);
        throw error;
    }
};

/// Restore Nationality
export const restoreNationality = async (id) => {
    try {
        const { data } = await axios.post(`nationalities/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreNationality error:", error);
        throw error;
    }
};

/// Restore multiple Nationalities
export const restoreAllNationalities = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "nationalities/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllNationalities error:", error);
        throw error;
    }
};

/// Force Delete Nationality
export const forceDeleteNationality = async (id) => {
    try {
        const { data } = await axios.delete(`nationalities/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteNationality error:", error);
        throw error;
    }
};

/// Force Delete multiple Nationalities
export const forceDeleteAllNationalities = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "nationalities/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllNationalities error:", error);
        throw error;
    }
};

/// Get Nationalities for Select Dropdown (optional, for future use)
export const getNationalitiesForSelect = async () => {
    try {
        const { data } = await axios.get("nationalities/for-select");
        return data;
    } catch (error) {
        console.error("getNationalitiesForSelect error:", error);
        throw error;
    }
};